export default __webpack_public_path__ + "static/media/ic_shib_16.b090ea5d.svg";